import React from 'react';
import { Info } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

// Mandatory methodology disclaimer shown directly beneath every chart.
const ChartNote = ({ methodology }) => {
  const { t } = useLang();
  return (
    <div className="mt-4 border-t border-slate-100 pt-3">
      {methodology && (
        <p className="text-[11.5px] font-medium text-slate-600 mb-1.5">{methodology}</p>
      )}
      <p className="flex items-start gap-1.5 text-[11.5px] leading-relaxed text-slate-500">
        <Info className="w-3.5 h-3.5 shrink-0 mt-0.5" aria-hidden="true" />
        <span>{t('common.chartNote')}</span>
      </p>
    </div>
  );
};

export default ChartNote;
